// extracted by mini-css-extract-plugin
export default {"container":"mj-z","blurb":"nj-z","links":"oj-z"};